type Props = {
	activeSubscriptions: number;
	newSubscriptions: number;
};

export const SubscriptionsCard: React.FC<Props> = ({
	activeSubscriptions,
	newSubscriptions,
}) => {
	return (
		<div className="bg-white rounded-xl shadow-md p-6 flex flex-col">
			<div className="flex items-center mb-4">
				<div className="p-3 bg-purple-100 rounded-lg">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						className="h-5 w-5 text-purple-600"
						viewBox="0 0 20 20"
						fill="currentColor"
					>
						<path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
					</svg>
				</div>
				<h2 className="ml-3 text-lg font-semibold text-gray-700">
					Assinaturas Ativas
				</h2>
			</div>
			<div className="text-3xl font-bold text-gray-800 mb-2">
				{activeSubscriptions}
			</div>
			<div className="flex items-center mt-auto">
				<span className="text-sm text-gray-500">
					{newSubscriptions} novas no último mês (30 dias)
				</span>
			</div>
		</div>
	);
};
